/* eslint-disable no-nested-ternary */
/**
 * request 网络请求工具
 * 更详细的 api 文档: https://github.com/umijs/umi-request
 */
import { Toast } from 'antd-mobile';
const qs = require('querystring');
import { extend } from 'umi-request';
import { default as router } from 'next/router';
import did from '@/services/did';
import { getUrlParams, carryUrlChan } from '@/utils/env';
import Storage from './storage';
import { decryptAES } from '@/utils/url';
import { EnumCacheKey } from '@/utils/storage';
import { handleRequestDecrypt, handleResponseDecrypt } from '@/utils/encrypt';

const codeMessage = {
  200: 'The server successfully returned the requested data',
  201: 'New or modified data successfully',
  202: '一个请求已经进入后台排队（异步任务）。',
  204: 'A request has been queued in the background (asynchronous task) to create or modify data successfully.',
  400: 'There was an error in the request, and the server did not create or modify the data.',
  401: 'The user does not have permissions (token, username, password error) .',
  403: 'The user is authorized, but access is denied.',
  404: 'Requests are made for records that do not exist, and the server does not operate.',
  406: 'The format of the request is not available.',
  410: 'The requested resource is permanently deleted and is no longer available.',
  422: 'A validation error occurred while creating an object.',
  500: 'An error has occurred on the server. Please check the server.',
  502: 'Bad Gateway',
  503: 'The service is unavailable and the server is temporarily overloaded or maintained.',
  504: 'Gateway Timeout'
};
/**
 * 异常处理程序
 */

const errorHandler = (error) => {
  const { response } = error;
  console.log('ERROR:', error);

  if (response && response.status) {
    const errorText = codeMessage[response.status] || response.statusText;
    Toast.show(errorText);
  } else if (!response) {
    Toast.show('error');
  }
  throw error; // ✅ 关键：抛出错误，不要 return response！
  // return response;
};

export const urlPreFix =
  process.env.NODE_ENV === 'development'
    ? ''
    : typeof window !== 'undefined'
    ? `${window.location.origin}`
    : process.env.API_HOST;

export const headers = {
  chan: getUrlParams('chan') || '',
  deviceId: did.getValue(),
  authorization: (Storage.getItem('authorization') && Storage.getItem('authorization')) || getUrlParams('token') || '',
  clientSys: 'h5',
  'X-Ph': getUrlParams('ph') ? decryptAES(getUrlParams('ph')) : '',
  webType: 'fantasy'
};

/**
 * 配置request请求时的默认参数
 */

const request = extend({
  timeout: 60 * 1000,
  errorHandler,
  // 默认错误处理
  credentials: 'include', // 默认请求是否带上cookie
  prefix: urlPreFix,
  headers
});

// 请求拦截器
request.interceptors.request.use(handleRequestDecrypt);

// 响应拦截器
request.interceptors.response.use(handleResponseDecrypt);

export const updateHeaders = (key, value) => {
  if (key === 'authorization' && !Storage.getItem('authorization')) {
    //if (key === 'authorization') {
    Storage.setItem('authorization', value);
    request.extendOptions({
      headers: {
        [key]: value
      }
    });
    headers[key] = value;
  }
};
export const updateHeadersNew = (key, value) => {
  console.log('reqwueqwe', request);

  if (key === 'tokenBind' && !Storage.getItem('tokenBind')) {
    request.extendOptions({
      headers: {
        [key]: value
      }
    });
    headers[key] = value;
  }
};
export const updateHeadersRegister = (key, value) => {
  //    if (key === 'authorization' && !Storage.getItem('authorization')) {
  if (key === 'authorization') {
    Storage.setItem('authorization', value);
    request.extendOptions({
      headers: {
        [key]: value
      }
    });
    headers[key] = value;
  }
};

const get = (url, params = null, other) => {
  return request.get(url, { params, ...other }).then((res) => {
    if (res && (res.error === 0 || res.code === 0) && res.data) {
      return Promise.resolve(res.data || {});
    } else if (res && (res.error === 0 || res.code === 0) && !res.data) {
      //兼容接口data直接返回true或false
      return Promise.resolve(res.data);
    }
    return Promise.reject(res);
  });
};

const post = (url, params = null, other) => {
  return request
    .post(url, {
      data: params,
      ...other,
      headers: {
        authorization: Storage.getItem('authorization')
          ? Storage.getItem('authorization')
          : url?.indexOf('loginBind') !== -1
          ? Storage.getItem('tokenBind')
          : ''
      }
    })
    .then((res) => {
      if (res && res.error == 1407010004) {
      }
      if (res && (res.error === 0 || res.code === 0)) {
        return Promise.resolve(res.data || {});
      }
      return Promise.reject(res);
    });
};

// const postForm = (url, params = null, other) => {
//   return request.post(url, { data: params, requestType: 'form', ...other }).then((res) => {
//     if (res && (res.error === 0 || res.code === 0)) {
//       return Promise.resolve(res.data);
//     }
//     return Promise.reject(res);
//   });
// };
const postForm = (url, params = null, other) => {
  return request
    .post(url, {
      data: params,
      requestType: 'form',
      ...other
    })
    .then((res) => {
      if (res && (res.error === 0 || res.code === 0)) {
        return Promise.resolve(res.data);
      }

      return Promise.reject(res);
    })
    .catch((err) => {
      // 抛出错误给上层
      throw err;
    });
};

const put = (url, params) => {
  return request.put(url, { data: params }).then((res) => {
    if (res && (res.error === 0 || res.code === 0)) {
      return Promise.resolve(res.data);
    }
    return Promise.reject(res);
  });
};

const toUrlEncoded = (params) => {
  return Object.keys(params)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
    .join('&');
};
const put2 = (url, params) => {
  console.log(params);

  const data2 = qs.stringify(params);
  return request
    .put(url, { data: data2, headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((res) => {
      if (res && (res.error === 0 || res.code === 0)) {
        return Promise.resolve(res.data);
      }
      return Promise.reject(res);
    });
};
const deleteItem = (url, params) => {
  return request.delete(url, { params }).then((res) => {
    if (res && (res.error === 0 || res.code === 0)) {
      return Promise.resolve(res.data);
    }
    return Promise.reject(res);
  });
};

//跳转路由前销毁弹窗
const closeModal = () => {
  const elements = document.querySelectorAll('div.adm-center-popup');
  elements.forEach((element) => {
    console.log(element);
    element.remove();
  });
};
export const loginExpire = (res) => {
  const loader = Toast.show({ content: res });
  Storage.setItem('authorization', '');
  Storage.setItem(EnumCacheKey['app/user/uid'], '');
  closeModal();
  setTimeout(() => {
    loader?.close();
    router.push(carryUrlChan('/login/'));
  }, 1000);
};

export { get, post, postForm, put, put2, deleteItem };
export default request;
